/**
 * Tenerfit brand / business metadata. Shares the design-system architecture
 * with its sister app tenerfisio-app but has its own visual identity, copy,
 * and service catalogue.
 */

export const brand = {
  id: 'tenerfit',
  name: 'Tenerfit',
  legalName: 'Isaac Hernández Negrín',
  legalNif: '79065715H',
  tagline: {
    es: 'Entrenamiento personal y funcional en Tenerife',
    en: 'Personal and functional training in Tenerife',
  },
  description: {
    es: 'Gimnasio y centro de entrenamiento personal en Tenerife. Entrenamiento funcional, fuerza y acondicionamiento físico adaptados a tu nivel y objetivos, con profesionales cualificados.',
    en: 'Gym and personal training studio in Tenerife. Functional training, strength and conditioning tailored to your level and goals, led by qualified coaches.',
  },
  url: 'https://www.tenerfit.com',
  googleMapsUrl:
    'https://www.google.com/maps/search/?api=1&query=Tenerfit%2C+Fern%C3%A1ndez+Navarro+34%2C+Santa+Cruz+de+Tenerife',
  logo: '/og-image.png',
  practitioner: {
    name: 'Isaac Hernández Negrín',
    licenseNumber: '',
  },
  contact: {
    landline: '+34922089379',
    landlineDisplay: '+34 922 08 93 79',
    mobile: '+34680966978',
    mobileDisplay: '+34 680 966 978',
    phone: '+34922089379',
    phoneDisplay: '+34 922 08 93 79',
    whatsapp: 'https://wa.me/34680966978',
    email: 'info@tenerfit.com',
    facebook: 'https://www.facebook.com/Tenerfit',
    instagram: 'https://www.instagram.com/tenerfit/',
    youtube: 'https://www.youtube.com/channel/UCXnLmAPbwRdKQ0a9a8goL-Q/videos',
  },
  address: {
    street: 'Fernández Navarro 34',
    locality: 'Santa Cruz de Tenerife',
    region: 'Santa Cruz de Tenerife',
    postalCode: '38003',
    country: 'ES',
  },
  geo: {
    latitude: 28.4610011,
    longitude: -16.254198,
  },
  locales: ['es', 'en'] as const,
  defaultLocale: 'es' as const,
  services: [
    { id: 'funcional', es: 'Entrenamiento funcional', en: 'Functional training' },
    { id: 'fuerza', es: 'Fuerza y acondicionamiento', en: 'Strength & conditioning' },
    { id: 'personal', es: 'Entrenamiento personal', en: 'Personal training' },
  ],
  openingHours: [
    { days: ['Mo', 'Tu', 'We', 'Th', 'Fr'], opens: '07:00', closes: '12:00' },
    { days: ['Mo', 'Tu', 'We', 'Th', 'Fr'], opens: '15:00', closes: '22:00' },
  ],
  aggregateRating: {
    ratingValue: 5.0,
    reviewCount: 249,
  },
  customerPortalUrl: 'https://tenerfit.weappfit.com',
} as const;

export type Locale = (typeof brand.locales)[number];
export const isLocale = (x: string): x is Locale =>
  (brand.locales as readonly string[]).includes(x);
